import EnvVars from "~/env-vars"

/** The `/solar-proposal` prefix is its own tree, like `/battery-proposal`.
 * While the page is partial it claims the prefix only where the flag is on;
 * elsewhere the path falls through to the legacy app as before. */
export const isSolarProposalPath = (pathname: string): boolean =>
  EnvVars.SOLAR_PROPOSAL_V2_ENABLED &&
  (pathname === `/solar-proposal` || pathname.startsWith(`/solar-proposal/`))
